// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: 218948666
// </auto-generated>
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Observable, Subject, Subscription } from 'rxjs';
import { SmartListResult, SmartListCriteria } from 'carehub-shared/smartlist';
import { Utils } from 'carehub-shared/utils';

import { Drg } from './models/common/drg';

@Injectable({
  providedIn: 'root',
})
export class DrgApiService {
  constructor(protected http: HttpClient) {}

  getDrgByCode(drgCode: string): Observable<Drg> {
    const url = environment.chiliSauceApiRoot + `/api/Drg/${drgCode}`;
    return this.http.get<Drg>(url);
  }
}
